import DataGridComponent from 'components/DataGrid/DataGridComponent';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import BPRegionForm from './BpRegionForm';
import { APIEndpoints } from 'helpers/APILists';
import {
    bpRegionApiEndpoint, bpRegionHeaderData,
    bpRegionInitialState, bpRegionSearchState
} from './BpRegion.data';
import { formatDate } from 'helpers/DateFormatter';
import { trackErrors } from '../helper';
import { MESSAGE_TYPE } from 'journeys/common/common.constants';
import { AdminConstants } from '../../AdminScreen.constants';

const addTitle = 'Add New Record for BP Region';
const editTitle = 'Edit Record for BP Region';
const formatDateIfExists = (date) => date && formatDate(new Date(date));
const getStatus = (status) => status ? 'Active' : 'Inactive';

const BpRegion = () => {
    const apiEndpoints = bpRegionApiEndpoint;
    const [showModal, setShowModal] = useState(false);
    const [editRowData, setEditRowData] = useState(bpRegionInitialState);
    const [modalTitle, setModalTitle] = useState(addTitle);
    const [refreshDatagrid, setRefreshDatagrid] = useState(false);
    const [bpRegionOptions, setBpRegionOptions] = useState([]);
    const [regionTypeOptions, setRegionTypeOptions] = useState([]);

    const [rowDetails, setRowDetails] = useState({
        columnName: 'RegionId',
        rowNumber: ''
    });

    const fetchBpRegionOptions = () => {
        axios.get(APIEndpoints.GetMratGroupMappings)
            .then((res) => {
                const options = res.data
                    .filter(y => y.Status === AdminConstants.LIVE_STATUS)
                    .map(x => ({ BpRegion: x.BpRegion, BpRegionAlias: x.BpRegionNameAlias }));
                setBpRegionOptions(options);
            })
            .catch((err) => {
                trackErrors({
                    messageType: MESSAGE_TYPE.ERROR,
                    message: err.message,
                    exception: err
                });
            });
    };

    const fetchRegionTypeOptions = () => {
        axios.get(APIEndpoints.ADMIN_GetRegionTypeLkup)
            .then((res) => {
                setRegionTypeOptions((res.data.filter(y => y.Status === AdminConstants.ACTIVE).map(x => ({ RowId: x.RowId, RegionType: x.RegionType }))));
            })
            .catch((err) => {
                trackErrors({
                    messageType: MESSAGE_TYPE.ERROR,
                    message: err.message,
                    exception: err
                });
            });
    };
    useEffect(() => {
        fetchBpRegionOptions();
        fetchRegionTypeOptions();
    }, []);

    const parseData = async (data) => {
        try {
            return data.map(item => ({
                ...item,
                MratDpsLastRefreshDate: formatDateIfExists(item.MratDpsLastRefreshDate),
                SapLastRefreshDate: formatDateIfExists(item.SapLastRefreshDate),
                Active: getStatus(item?.Active),
                MratDpsActive: getStatus(item?.MratDpsActive),
                DraftStatus: getStatus(item?.DraftStatus),
                IsLateEntry: getStatus(item?.IsLateEntry),
            }));
        } catch (err) {
            trackErrors({
                messageType: MESSAGE_TYPE.ERROR,
                message: err.message,
                exception: err
            });
            throw err;
        }
    };

    const handleEditRecord = (obj) => {
        const rowData = obj.row;
        setModalTitle(editTitle);
        setShowModal(true);
        setEditRowData((prev) => ({
            ...prev,
            ...rowData
        }));
    };
    const handleAddRecord = () => {
        setEditRowData(bpRegionInitialState);
        setModalTitle(addTitle);
        setShowModal(true);
    };

    const handleModalClose = () => {
        setShowModal(false);
    };

    const handleRecordSubmit = (newId) => {
        setRefreshDatagrid(prev => !prev);
        setRowDetails(prev => ({ ...prev, rowNumber: newId }));
    };

    return (
        <>
            <DataGridComponent
                headerData={bpRegionHeaderData}
                apiEndpoint={apiEndpoints.read}
                editRecord={handleEditRecord}
                addRecord={handleAddRecord}
                rowDetails={rowDetails}
                dataParser={parseData}
                initialData={bpRegionSearchState}
                refreshDatagrid={refreshDatagrid}
            />

            {showModal
                && (
                    <BPRegionForm
                        isOpen={showModal}
                        onClose={handleModalClose}
                        title={modalTitle}
                        rowData={editRowData}
                        onRecordSubmit={handleRecordSubmit}
                        bpRegionOptions={bpRegionOptions}
                        regionTypeOptions={regionTypeOptions}
                    />
                )}
        </>
    );
};

export default BpRegion;
